<script setup lang="ts">
import { CombinedError } from '@urql/vue';
import { computed } from 'vue';
import { clean } from '@stl/filters';

const props = defineProps<{
  variant: 'danger' | 'warning' | 'success' | 'info';
  error?: CombinedError | string | null;
  message?: string;
}>();

const message = computed(() => {
  if (props.message) {
    return props.message;
  }
  if (!props.error) {
    return null;
  }
  return (props.error as CombinedError).message || (props.error as string);
});
</script>

<template lang="pug">
.alert(:class="'alert-' + variant")
  FontAwesomeIcon.ms-2.me-2(v-if="variant == 'danger'" icon="circle-exclamation")
  FontAwesomeIcon.ms-2.me-2(v-if="variant == 'warning'" icon="triangle-exclamation")
  FontAwesomeIcon.ms-2.me-2(v-if="variant == 'success'" icon="circle-check")
  FontAwesomeIcon.ms-2.me-2(v-if="variant == 'info'" icon="circle-info")
  span(v-if="message") {{ clean(message) }}
  slot
</template>
